<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>经营者收入申报明细</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">经营者收入申报明细</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item label="任务编号">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.jobNo"
                    placeholder="请输入任务编号"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item>
                  <el-button type="primary" @click="getList('new')" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <!-- <div style="margin-bottom: 20px">
          <el-button type="primary" @click="dowon()" class="btn"
            >税务申报模板下载</el-button
          >
          <el-button type="primary" @click="exportList()" class="btn"
            >导出申报excel</el-button
          >
        </div> -->

        <el-table
          :data="tableData"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          tooltip-effect="dark"
          ref="multipleTable"
        >
          <el-table-column
            prop="billDetailNo"
            label="账单编号"
            align="center"
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="memberName"
            label="用户名"
            align="center"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="memberTypeName"
            label="用户类型"
            align="center"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="memberPhone"
            label="电话"
            align="center"
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="jobNo"
            label="任务编号"
            align="center"
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="businessTypeName"
            label="业务类型"
            align="center"
            width="160"
          >
          </el-table-column>
          <el-table-column
            prop="changeName"
            label="变动类型"
            align="center"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="actualAmount"
            label="实际到账金额"
            align="center"
            width="160"
          >
          </el-table-column>
          <el-table-column
            prop="taxAmount"
            label="税费"
            align="center"
            width="160"
          >
          </el-table-column>
          <el-table-column
            prop="actualPlatformRate"
            label="实际平台费比例(扣除保安公司成本比例后的)"
            align="center"
            width="160"
          >
          </el-table-column>
          <el-table-column
            prop="saleServerIncomeAmount"
            label="销售服务资产取得的收入总额"
            align="center"
            width="160"
          >
          </el-table-column>
          <el-table-column
            prop="paidToPlatform"
            label="支付给平台的佣金、服务费合计金额"
            align="center"
            width="160"
          >
          </el-table-column>
          <el-table-column prop="memo" label="备注" align="center" width="180">
          </el-table-column>
          <el-table-column
            prop="changesAt"
            label="到账时间"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="gmtCreate"
            label="创建时间"
            align="center"
            width="180"
          >
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
      <TableScrollSlider :table-ref="$refs.multipleTable" />
    </div>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.taxData(),
      ruleForm: {
        jobNo: "",
      },
      tableData: [],
      errorList: [],
      page: 1,
      pageSize: 20,
      total: 0,
      multipleTable: [],
      failDesc: "",
      dialogVisible: false,
      dialogVisible1: false,
      selectData: {},
      status: "",
      num: "",
      type: "0", //0 单独数据处理   1批量数据确认
    };
  },
  mounted() {
    this.num = this.$route.query.id;
    this.getList();
  },
  methods: {
    dowon() {
      window.open(
        "http://down.baoanlailou.com/file/excel/template-劳务报酬所得（适用累计预扣法）.xls"
      );
    },
    handleClose() {
      this.dialogVisible = false;
      this.status = "";
      this.failDesc = "";
    },
    handleClose1() {
      this.dialogVisible1 = false;
    },
    exportList(key) {
      let arr = [];
      if (this.multipleTable.length != 0) {
        for (var i = 0; i < this.multipleTable.length; i++) {
          arr.push(this.multipleTable[i].id);
        }
      }
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        jobNo: this.ruleForm.jobNo,
        ids: arr,
      };

      this.$axios
        .post("/admapi/tax/workdetail/export", param, { responseType: "blob" })
        .then((data) => {
          console.log(data);
          this.$refs.multipleTable.clearSelection();
          let val = new Blob([data.data], {
            type: "application/vnd.ms-excel;charset=utf-8",
          });
          let header = decodeURI(data.headers["content-disposition"]);
          // console.log(header);
          let index = header.indexOf("''");
          let fileName = header.substring(index + 2, header.length);
          console.log(fileName);
          const url = window.URL.createObjectURL(val);
          const link = document.createElement("a");
          link.download = fileName; // 设置a标签的下载属性
          link.style.display = "none";
          link.href = url;
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href); // 下载完成释放URL 对象
          document.body.removeChild(link);
        })
        .catch()
        .finally();
      // );
    },
    InvoicingAll() {
      this.dialogVisible = true;
      this.type = "1";
      // this.$confirm("是否批量确认提现", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning"
      // })
      //   .then(() => {

      //   })
      //   .catch(() => {});
    },
    confrim() {
      if (this.status == "") {
        return;
      }
      if (this.status == "0") {
        if (this.failDesc == "") {
          this.$message({
            message: "请输入失败原因",
            type: "warning",
          });
          return;
        }
      }
      if (this.type == "0") {
        let param = {
          id: this.selectData.id,
          state: this.status,
          failDesc: this.failDesc,
        };
        this.$axios
          .post(`/admapi/withdraw/tempconfirm`, param)
          .then(({ data }) => {
            this.$message({
              message: "确认成功",
              type: "success",
            });
            this.dialogVisible = false;
            this.getList();
          })
          .catch()
          .finally();
      } else {
        if (this.multipleTable.length == 0) {
          this.$message({
            message: "请选择确认数据",
            type: "warning",
          });
          return;
        }
        let arr = [];
        for (var i = 0; i < this.multipleTable.length; i++) {
          arr.push(this.multipleTable[i].id);
        }
        let param = {
          ids: arr,
          state: this.status,
          failDesc: this.failDesc,
        };
        this.$axios
          .post(`/admapi/withdraw/tempbatchconfirm`, param)
          .then(({ data }) => {
            console.log(data);
            if (data.errorCount != 0) {
              this.errorList = data.errorMessages;
              this.dialogVisible1 = true;
            } else {
              this.$message({
                message: "批量确认成功",
                type: "success",
              });
            }
            this.multipleTable = [];
            this.$refs.multipleTable.clearSelection();
            this.getList();
            this.dialogVisible = false;
          })
          .catch()
          .finally();
      }
    },
    Invoicing(val) {
      this.dialogVisible = true;
      this.type = "0";
      this.selectData = val;
      // this.$confirm("是否确认提现", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning"
      // })
      //   .then(() => {

      //   })
      //   .catch(() => {});
    },
    handleSelectionChange(val) {
      this.multipleTable = val;
    },
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.status = "";
      this.ruleForm.phone = "";
      this.ruleForm.jobNo = "";
      this.ruleForm.id = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList(val) {
      if (val == "new") {
        this.page = 1;
      }
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        managerDeclarationNo: this.num,
        jobNo: this.ruleForm.jobNo,
      };
      this.$axios
        .post(`/admapi/tax/manager/declare/detaillist`, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
  },
};
</script>
<style>
.el-popover {
  padding: 0px 16px !important;
  box-sizing: border-box;
  border: none;
  min-width: 0;
}
</style>
